import { type KeyboardEventHandler, type ReactNode } from "react";

import { cn } from "../utils/styling";

type ChipProps = {
  children: ReactNode;
  className?: string;
  disabled?: boolean;
  height?: number | string;
  isOn?: boolean;
  onClick?: () => void;
  width?: number | string;
};

const Chip = ({ children, className, disabled, height, isOn, onClick, width }: ChipProps) => {
  const isInteractive = Boolean(onClick) && !disabled;

  const handleKeyDown: KeyboardEventHandler<HTMLDivElement> = (event) => {
    if (!onClick || disabled) return;
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <div
      aria-disabled={disabled || undefined}
      className={cn(
        "flex !h-ds-2x items-center justify-center rounded-ds-0-25x bg-lds-surface-bright px-3 outline-none !font-ds-body-regular-md",
        isInteractive && "cursor-pointer",
        "hover:text-lds-foreground-heading-active focus-visible:border-ds-focus",
        !isOn && "text-lds-foreground-primary border-ds-strong  hover:bg-lds-selection-strong",
        isOn && "bg-lds-selection-subtle text-lds-foreground-heading-active border-ds-accent",
        disabled &&
          "pointer-events-none cursor-not-allowed bg-transparent text-lds-element-disabled-on border-ds-subtle hover:bg-transparent",
        className
      )}
      onClick={disabled ? undefined : onClick}
      onKeyDown={handleKeyDown}
      role={isInteractive ? "button" : undefined}
      style={{ height, width }}
      tabIndex={isInteractive ? 0 : undefined}
    >
      {children}
    </div>
  );
};

export default Chip;
